<template>
  <div class="blog-lst col-md-12 col-sm-12 col-xs-12 pl0" style="padding: 15px">
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest == null">
      <div class="panel-heading">
        <h3 class="panel-title">{{ $t('labels.requests_overview') }}</h3>
      </div>
      <div class="panel-body text-widget">
        <div class="table-responsive">
          <table class="table table-striped table-condensed">
            <thead>
              <tr>
                <th>{{ $t('table.id') }}</th>
                <th>{{ $t('table.exhibition') }}</th>
                <th>{{ $t('table.booth') }}</th>
                <th>{{ $t('table.status') }}</th>
                <th>{{ $t('table.created_at') }}</th>
                <th>{{ $t('table.updated_at') }}</th>
                <th>{{ $t('table.options') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests" v-bind="request" :key="request.id">
                <td>{{ request.id }}</td>
                <td>{{ request.exhibition.name }} ({{ $filters.formatDate(request.exhibition.from) }} - {{ $filters.formatDate(request.exhibition.till) }})</td>
                <td v-if="request.booth != null">{{ request.booth.name }}</td>
                <td v-else></td>
                <td></td>
                <td>{{ $filters.formatDate(request.created_at) }} Uhr</td>
                <td>{{ $filters.formatDate(request.updated_at) }} Uhr</td>
                <td>
                  <button type="button" class="btn btn-default btn-sm btn-border" @click="selectRequest(request)">
                  {{ $t('buttons.show') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest">
      <div class="panel-heading">
        <h3 class="panel-title">{{ $t('labels.summary') }} - {{ exhibitionName }}</h3>
      </div>
      <div class="panel-body text-widget">
        <div class="col-md-6">
          <div class="row">
            <h4>{{ $t('labels.address') }}</h4>
            <div class="col-md-12">
              {{ selectedRequest.name }}
            </div>
            <div class="col-md-12" v-if="selectedRequest.company">
              {{ selectedRequest.company }}
            </div>
            <div class="col-md-12">
              {{ selectedRequest.street_name }} {{ selectedRequest.street_number }}
            </div>
            <div class="col-md-12">
              {{ selectedRequest.zip }} {{ selectedRequest.place }}
            </div>
            <div class="col-md-12">
              {{ (inEnglish) ? selectedRequest.country.name_en : selectedRequest.country.name }}
            </div>

            <div v-if="selectedRequest.has_bill_address">
              <h4>{{ $t('labels.payment_address') }}</h4>
              <div class="col-md-12">
                {{ selectedRequest.bill_company }}
              </div>
              <div class="col-md-12">
                {{ selectedRequest.bill_name }} x {{ selectedRequest.has_bill_address }}
              </div>
              <div class="col-md-12">
                {{ selectedRequest.bill_street_name }} {{ selectedRequest.bill_street_number }}
              </div>
              <div class="col-md-12">
                {{ selectedRequest.bill_zip }} {{ selectedRequest.bill_place }}
              </div>
              <div class="col-md-12">
                {{ (inEnglish) ? selectedRequest.bill_country.name_en : selectedRequest.bill_country.name }}
              </div>
              <div class="col-md-12">
                {{ selectedRequest.bill_email }}
              </div>
              <div class="col-md-12">
                {{ selectedRequest.bill_phone }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-5"><b>{{ $t('labels.email') }}</b></div>
            <div class="col-md-7">{{ selectedRequest.email }}</div>
            <div class="col-md-5" v-show="selectedRequest.phone != null && selectedRequest.phone != ''"><b>{{ $t('labels.phone') }}</b></div>
            <div class="col-md-7" v-show="selectedRequest.phone != null && selectedRequest.phone != ''">{{ selectedRequest.phone }}</div>
            <div class="col-md-5" v-show="selectedRequest.exhibition_hall != null && selectedRequest.exhibition_hall != ''"><b>{{ $t('labels.exhibition_hall') }}</b></div>
            <div class="col-md-7" v-show="selectedRequest.exhibition_hall != null && selectedRequest.exhibition_hall != ''">{{ selectedRequest.exhibition_hall }}</div>
            <div class="col-md-5" v-show="selectedRequest.exhibition_booth_number != null && selectedRequest.exhibition_booth_number != ''"><b>{{ $t('labels.exhibition_booth_number') }}</b></div>
            <div class="col-md-7" v-show="selectedRequest.exhibition_booth_number != null && selectedRequest.exhibition_booth_number != ''">{{ selectedRequest.exhibition_booth_number }}</div>
            <div class="col-md-5" v-show="selectedRequest.order_number != null && selectedRequest.order_number != ''"><b>{{ $t('labels.order_number') }}</b></div>
            <div class="col-md-7" v-show="selectedRequest.order_number != null && selectedRequest.order_number != ''">{{ selectedRequest.order_number }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <a @click="unselectRequest()"><i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest && selectedBooth != null">
      <div class="panel-heading">
        <h3 class="panel-title" v-if="selectedBooth != null">{{ $t("summary.package") }}</h3>
      </div>
      <div class="panel-body text-widget">
        <table class="table summery-table" v-if="selectedBooth != null">
          <thead>
            <tr>
              <th class="hidden-xs"></th>
              <th>{{ $t("basket.item") }}</th>
              <th class="text-right">{{ $t("basket.price_in") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="selectedBooth != null">
              <td rowspan="2" class="hidden-xs"><img :src="selectedBooth.images[selectedRequest.booth_type][0].imagePath" height="50px" v-if="hasSelectedBoothImage"></td>
              <td>
                {{ $t("basket.booth_package") }} (<span v-if="selectedBooth != null">{{ boothName }}</span>)<br>
                <span v-if="selectedRequest.carpetColor != null">{{ $t("basket.carpetColor") }}:
                  <span class="color-span" :style="'background-color: ' + selectedRequest.carpetColor.hex"></span>
                </span>
              </td>
              <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.boothCost) }}</td>
            </tr>
            <tr v-show="selectedBooth != null">
              <td class="hidden-xs">{{ selectedRequest.booth_label }}</td>
              <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.labelCost) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-12">
            <a @click="unselectRequest()"><i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest && showArticlesSection">
      <div class="panel-heading">
          <h3 class="panel-title">{{ $t("summary.articles") }}</h3>
      </div>
      <div class="panel-body text-widget">
        <table class="table summery-table article-table">
          <thead>
            <tr>
              <th class="hidden-xs"></th>
              <th>{{ $t("basket.item") }}</th>
              <th class="text-right">{{ (showVat) ? $t("basket.netPrice") : $t("basket.price_in") }}</th>
              <th v-if="showVat" class="text-right">{{ $t("basket.vatPrice") }}</th>
              <th v-if="showVat" class="text-right">{{ $t("basket.price_in") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in selectedArticles"
              v-bind:value="article"
              v-show="article.amount > 0"
              :key="article.id">
              <td class="hidden-xs">
                <img v-if="hasArticleImages(article)"
                  :src="'/images/articles/' + article.article.images[0].path"
                  height="50px">
                <img v-else :src="ARTICLE_DEFAULT_IMAGE" height="50px">
              </td>
              <td v-if="article.unit && article.unit !== 'pc'">
                {{ (inEnglish) ? article.article.name_en : article.article.name }}{{ article.amount }}m<sup>2</sup> <small v-show="article.inclusive > 0">({{ article.inclusive }}  m<sup>2</sup> incl.)</small><br>

                {{ $filters.formatMoney(article.price_per_unit) }} / m<sup>2</sup>
              </td>
              <td v-else>
                {{ article.amount }}xx {{ (inEnglish) ? article.article.name_en : article.article.name }} <small v-show="article.inclusive > 0">({{ article.inclusive }} incl.)</small><br>
                {{ $filters.formatMoney(article.price_per_unit) }} / Stück
              </td>
              <td class="text-right">{{ $filters.formatMoney(article.price_total_net) }}</td>
              <td v-if="showVat" class="text-right">
                {{ $filters.formatMoney(article.price_total - article.price_total_net) }}
              </td>
              <td v-if="showVat" class="text-right">
                {{ $filters.formatMoney(article.price_total) }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-12">
            <a @click="unselectRequest"><i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest && hasExtraCosts">
      <div class="panel-heading">
        <h3 class="panel-title">{{ $t("summary.other_costs") }} <small>({{ $t("summary.other_costs_notice") }})</small></h3>
      </div>
      <div class="panel-body text-widget">
        <table class="table summery-table">
          <thead>
            <tr>
              <th class="hidden-xs"></th>
              <th>{{ $t("basket.item") }}</th>
              <th class="text-right">{{ $t("basket.price_in") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="selectedRequest.computed_prices.additionalCosts != null && selectedRequest.computed_prices.additionalCosts.length > 0"
                v-for="cost,index in selectedRequest.computed_prices.additionalCosts"
                v-bind:value="cost"
                :key="index">
              <td class="hidden-xs"></td>
              <td>{{ cost.displayName }}:</td>
              <td class="text-right">{{ $filters.formatMoney(cost.amount) }}</td>
            </tr>
            <tr v-if="selectedRequest.computed_prices.exhibitionFlatFee != null && selectedRequest.computed_prices.exhibitionFlatFee">
              <td class="hidden-xs"></td>
              <td>{{ $t("basket.media_package") }}:</td>
              <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.exhibitionFlatFee) }}</td>
            </tr>
            <tr v-show="selectedRequest.computed_prices.exhibitionDisposalCost != null && selectedRequest.computed_prices.exhibitionDisposalCost">
              <td class="hidden-xs"></td>
              <td>{{ $t("basket.disposal_costs") }}:</td>
              <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.exhibitionDisposalCost) }}</td>
            </tr>
            <tr v-show="selectedRequest.computed_prices.exhibitionRentCost">
              <td class="hidden-xs"><div class="booth active" v-if="selectedRequest.booth_type" v-bind:class="$filters.formatBoothTypeClass(selectedRequest.booth_type)"></div></td>
              <td>
                {{ $t("basket.rent") }}<br>
                <div class="row" v-if="(selectedRequest.booth_width > 0 && selectedRequest.booth_depth > 0) || selectedRequest.booth_type != null">
                  <span class="col-xs-12" v-if="selectedRequest.booth_type != null"><b>{{ $t("basket.booth_type") }}: </b>{{  $t('boothTypes.' + selectedRequest.booth_type) }}</span>
                  <span class="col-xs-12" v-if="selectedRequest.booth_width > 0 && selectedRequest.booth_depth > 0"><b>{{ $t("basket.size") }}: </b>{{ $filters.formatLength(selectedRequest.booth_width) }} x {{ $filters.formatLength(selectedRequest.booth_depth) }} m ({{ $filters.formatLength(selectedRequest.computed_prices.squareMeter) }} {{ $t("labels.sqm") }})</span>
                </div>
              </td>
              <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.exhibitionRentCost) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-12">
            <a @click="unselectRequest"><i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="requests-block panel panel-default sidebar-menu wow fadeInLeft animated" style="visibility: visible;" v-if="selectedRequest">
      <div class="panel-heading">
        <h3 class="panel-title">{{ $t('labels.summary') }}</h3>
      </div>
      <div class="panel-body text-widget">
        <table class="table summery-table">
          <thead>
            <tr>
              <th class="hidden-xs"></th>
              <th>{{ $t("basket.item") }}</th>
              <th class="text-right">{{ $t("basket.price_in") }}</th>
            </tr>
          </thead>
          <tfoot>
          <tr v-show="selectedRequest.computed_prices.isLateDeliverySurchargeActive">
            <td class="hidden-xs"></td>
            <td>{{ $t("basket.late_delivery") }} ({{ selectedExhibition.late_delivery.surcharge_in_percent }}%):</td>
            <td class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.lateDeliveryCost) }}</td>
          </tr>
          <tr>
            <th class="hidden-xs"></th>
            <th>{{ $t("basket.total") }}:</th>
            <th class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.total) }}</th>
          </tr>
          <tr v-if="showVat">
            <th class="hidden-xs"></th>
            <th>{{ $t("basket.total_gross_summary") }}:</th>
            <th class="text-right">{{ $filters.formatMoney(selectedRequest.computed_prices.total_gross) }}</th>
          </tr>
          </tfoot>
        </table>
        <div class="row">
          <div class="col-md-12">
            <a @click="unselectRequest"><i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useMainStore } from '@/store'
import { cloneDeep } from 'lodash'
import { ARTICLE_DEFAULT_IMAGE } from '@/constants'

const store = useMainStore()
// define props
const props = defineProps({
  requests: {
    type: Array,
    default: [],
  },
})
// define reactive props
const selectedRequest = ref(null)
const selectedExhibition = ref(null)
const selectedBooth = ref(null)
const selectedArticles = ref(null)
const showArticlesSection = ref(false)
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === "en"
})

const exhibitionName = computed(() => {
  if (selectedExhibition.value === null) {
    return ""
  }

  return (inEnglish.value)
    ? selectedExhibition.value.name_en
    : selectedExhibition.value.name
})

const boothName = computed(() => {
  if (selectedBooth.value === null) {
    return ""
  }

  return (inEnglish.value)
    ? selectedBooth.value.name_en
    : selectedBooth.value.name
})

const hasSelectedBoothImage = computed(() => {
  if (selectedBooth.value === null && selectedRequest.value !== null) {
    return false
  }

  if (
    selectedBooth.value.images === null
    || selectedBooth.value.images[selectedRequest.value.booth_type] === null) {
    return false
  }

  return (selectedBooth.value.images[selectedRequest.value.booth_type].length > 0)
})

const showVat = computed(() => {
  if (selectedRequest.value === null) {
    return false
  }

  return (selectedRequest.value.has_bill_address)
    ? selectedRequest.value.bill_country.vat_display_required
    : selectedRequest.value.country.vat_display_required
})

const hasExtraCosts = computed(() => {
  if (selectedRequest.value === null) {
    return false
  }

  return (
    selectedRequest.value.computed_prices.additionalCosts !== null
    && selectedRequest.value.computed_prices.additionalCosts.length > 0
    && selectedRequest.value.computed_prices.exhibitionFlatFee !== null
    && selectedRequest.value.computed_prices.exhibitionFlatFee
    && selectedRequest.value.computed_prices.exhibitionDisposalCost !== null
    && selectedRequest.value.computed_prices.exhibitionDisposalCost
    && selectedRequest.value.computed_prices.exhibitionRentCost
  )
})
// define methods
const selectRequest = (request) => {
  selectedRequest.value = request
  selectedBooth.value = request.booth
  selectedExhibition.value = request.exhibition
  // selectedArticles.value = request.articles
	const items = {}
	request.articles.forEach((item) => {
		if (!items.hasOwnProperty(item.article_id)) {
			items[item.article_id] = cloneDeep(item)
		} else {
			items[item.article_id].amount += parseFloat(item.amount)
			items[item.article_id].inclusive += parseFloat(item.inclusive)
			items[item.article_id].price_total += parseFloat(item.price_total)
			items[item.article_id].price_total_net += parseFloat(item.price_total_net)
		}
	})

  selectedArticles.value = Object.values(items)
  for (let i = 0; i < selectedArticles.value.length; i++) {
    const article = selectedArticles.value[i]
    if (article.amount > 0) {
      showArticlesSection.value = true
      break
    }
  }
}

const unselectRequest = () => {
  selectedRequest.value = null
  selectedBooth.value = null
  selectedExhibition.value = null
  selectedArticles.value = null
  showArticlesSection.value = false
}

const hasArticleImages = (article) => {
  if (article.article.images === null) {
    return false
  }

  return (article.article.images.length > 0)
}
</script>